import { render, staticRenderFns } from "./MyCursor.vue?vue&type=template&id=5b0177f5&"
import script from "./MyCursor.vue?vue&type=script&lang=js&"
export * from "./MyCursor.vue?vue&type=script&lang=js&"
import style0 from "./MyCursor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports